import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  DeliveryRetryApiService,
  DeliveryRetryConfigDTO,
  DeliveryRetryConfigVO,
  LogisticsCreateDTO,
} from '@app/api/order-service/api/deliveryRetryApi.service';

export interface DeliveryRetryConfigItem {
  id?: number;
  retryDelayMinutes: number;
  enabled: boolean;
}

@Injectable({ providedIn: 'root' })
export class DeliveryRetryFeatureService {
  private readonly api = inject(DeliveryRetryApiService);

  getConfig(): Observable<DeliveryRetryConfigItem> {
    return this.api.getConfig().pipe(map((vo) => this.mapVo(vo)));
  }

  updateConfig(
    item: DeliveryRetryConfigItem,
  ): Observable<DeliveryRetryConfigItem> {
    const dto: DeliveryRetryConfigDTO = {
      id: item.id,
      retryDelayMinutes: item.retryDelayMinutes,
      enabled: item.enabled,
    };
    return this.api.updateConfig(dto).pipe(map((vo) => this.mapVo(vo)));
  }

  retryDelivery(orderId: number, body?: LogisticsCreateDTO): Observable<unknown> {
    return this.api.retryDelivery(orderId, body);
  }

  returnStock(orderId: number, note?: string): Observable<string> {
    return this.api.returnStock(orderId, note);
  }

  markDeliveryFailed(orderId: number, note?: string): Observable<void> {
    return this.api.markDeliveryFailed(orderId, note);
  }

  private mapVo(vo: DeliveryRetryConfigVO): DeliveryRetryConfigItem {
    return {
      id: vo.id,
      retryDelayMinutes: vo.retryDelayMinutes ?? 120,
      enabled: vo.enabled !== false,
    };
  }
}
